
import { mapGetters, mapState } from 'vuex'
import DataTable from '~/mixins/dataTable'
import countryCode from '~/static/json/countryCode.json'
export default {
    name: 'ProfilePage',
    mixins: [DataTable],
    data: () => ({
        tempPhone: null,
        valid: false,
        formValid: false,
        formValidBank: true,
        phone: null,
        edit: {},
        showCreateBankAccountCard: false,
        showPassword: false,
        form: {
            bank_id: null,
            bank_account_number: null,
            account_holder_name: null,
        },
        credential: {
            newPassword: null,
            confirmPassword: null,
        },
        loading: false,
        country_code: null,
    }),
    computed: {
        ...mapState({
            loadingPlayer: (state) => state.player.loading,
            player: (state) => state.player.player,
            accounts: (state) => state.banks.accounts,
            loadingBankAccount: (state) => state.banks.loading,
            banks: (state) => state.banks.banks,
            createdBankAccount: (state) => state.banks.created,
            cardHolderName: (state) => state.banks.cardHolderName,
        }),
        ...mapGetters({
            languages: 'settings/languages',
            countries: 'settings/countries',
        }),
    },
    watch: {
        player(value) {
            this.phone = value.phone
            this.form.account_holder_name = value.name
            this.filterCountryCode(value.phone)
        },
        'credential.newPassword'(value) {
            if (this.credential.confirmPassword) {
                if (
                    this.credential.newPassword !==
                    this.credential.confirmPassword
                ) {
                    this.formValid = false
                } else {
                    this.formValid = true
                }
            }
        },
    },
    async mounted() {
        await this.$store.dispatch('settings/languages')
        await this.$store.dispatch('settings/countries')
        this.$store.dispatch('banks/accounts')
        this.$store.dispatch('banks/banks')
        this.$store.dispatch('player/profile')
    },
    methods: {
        uppercase() {
            this.form.account_holder_name =
                this.form.account_holder_name.toUpperCase()
        },
        onPhoneUpdate(number) {
            this.edit.phone =
                '+' + number.countryCallingCode + number.phoneNumber
        },
        updatePlayer() {
            this.$store.dispatch('player/update', {
                phone: this.phone.replaceAll(/ /g, ''),
            })
        },
        async updatePassword() {
            if (this.formValid) {
                if (
                    this.credential.confirmPassword ===
                    this.credential.newPassword
                ) {
                    await this.$store.dispatch('player/update', {
                        password: this.credential.confirmPassword,
                    })
                } else {
                    this.formValid = false
                }
            }
        },
        onClickAddNewBankAccount() {
            this.showCreateBankAccountCard = true
        },
        async createBankAccount() {
            const form = { ...this.form }
            delete form.phone
            if (this.$refs.formBank.validate()) {
                if (!form.account_holder_name) {
                    form.account_holder_name = this.player.name
                }
                this.loading = true
                const response = await this.$store.dispatch(
                    'banks/create',
                    form
                )
                if (response) {
                    this.$toast.success(this.tl('bankAccountCreated'))
                    await this.$refs.formBank.reset()
                    this.form.account_holder_name = this.player.name
                }
                this.showCreateBankAccountCard = false
                this.loading = false
                return null
            }
        },
        transfer() {
            if (confirm(this.tl('sureTransfer'))) {
                this.$store.dispatch('player/transfer')
            }
        },
        referFriend() {
            this.$router.push('/referral')
        },
        filterCountryCode(value) {
            if (value) {
                const newCode = countryCode.find(
                    (code) => code.dial_code === value.slice(0, 5)
                )
                if (typeof newCode === 'object') {
                    this.country_code = newCode.code
                } else {
                    const newCode = countryCode.find(
                        (code) => code.dial_code === value.slice(0, 4)
                    )
                    if (typeof newCode === 'object') {
                        this.country_code = newCode.code
                    } else {
                        const newCode = countryCode.find(
                            (code) => code.dial_code === value.slice(0, 3)
                        )
                        if (typeof newCode === 'object') {
                            this.country_code = newCode.code
                        } else {
                            const newCode = countryCode.find(
                                (code) => code.dial_code === value.slice(0, 2)
                            )
                            this.country_code = newCode.code
                        }
                    }
                }
            }
        },
    },
}
